module.exports = __webpack_public_path__ + "static/media/logo-desktop-2x.197f1575.png";